import Vue from 'vue'
import VueRouter from 'vue-router'

import Splash from '../pages/Splash/Splash';
import SignInAdmin from '../pages/SignInAdmin/SignInAdmin';
import Standby from '../pages/Standby/Standby';
import UserSignIn from '../pages/UserSignIn/UserSignIn';
import Invoice from '../pages/Invoice/Invoice';
import PaymentCard from '../pages/PaymentCard/PaymentCard';
import Totem from '../pages/Totem/Totem';

import SecondWeb from '../pages/SecondWeb/SecondWeb';

Vue.use(VueRouter)

const routes = [
   
    {
        path: '/',
        name: 'Splash',
        component: Splash
    },
    {
        path: '/signinadmin/:dev?',
        name: 'SignInAdmin',
        component: SignInAdmin
    },
    {
        path: '/standby',
        name: 'Standby',
        component: Standby
    },
    {
        path: '/usersignin/:dev?',
        name: 'UserSignIn',
        component: UserSignIn
    },
    {
        path: '/invoice',
        name: 'Invoice',
        component: Invoice,
        props: true
    },
    {
        path: '/paymentcard',
        name: 'PaymentCard',
        component: PaymentCard,
        props: true
    },
    {
        path: '/totem',
        name: 'Totem',
        component: Totem,
        props: true
    },
    {
        path: '/2viaweb',
        name: 'SecondWeb',
        component: SecondWeb,
        props: true
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
  

export default router;